// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
	font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
	-webkit-text-size-adjust: 100%;
	margin: 0;
	padding: 0;
	font-size: 14px;
}

.single-survey {
	overflow: hidden !important;
	position: fixed;
	height: 100%;
	width: 100%;
	background: #f5f5f5;
}

.single-survey .current-survey-overlay {
	display: none;
}

.single-survey .cancel-button {
	display: none;
}

.single-survey.embedded .cancel-button {
	display: block;
}

.single-survey.webkit .cancel-button {
	display: block;
}

.single-survey.webkit .cancel-button {
	display: block;
}

.single-survey .completion-step .cancel-button {
	display: block;
}

.single-survey .visual-consent-learn-more .cancel-button {
	display: block;
}

.single-survey .survey-complete {
	padding: 16px;
	width: 100%;
	max-width: 768px;
	margin: 16px auto;
	box-sizing: border-box;
}

.single-survey .survey-complete .survey-complete-message {
	padding: 16px;
	font-size: 21px;
	background: #FFF;
	box-sizing: border-box;
	width: 100%;
	border-radius: 5px;
}

.single-survey .survey-complete .survey-complete-message .fa {
	font-size: 35px;
	display: block;
	margin-bottom: 8px;
}

.single-survey .survey-complete .survey-complete-message .fa-times-circle {
	color: #c4291c;
}

.single-survey .survey-complete .survey-complete-message .fa-check-circle {
	color: #5db37e;
}

.single-survey .saving-modal {
	display: none;
	z-index: 5003;
	position: fixed;
	padding: 24px;
	top: 50px;
	left: 50%;
	min-width: 360px;
	max-height: calc(100vh - 80px);
	transform: translate(-50%, 0);
	-webkit-transform: translate(-50%, 0);
	-moz-transform: translate(-50%, 0);
	background-color: #fff;
	border-radius: 5px;
	overflow: hidden;
}

.single-survey .overlay {
	position: fixed;
	left: 0;
	top: 0;
	bottom: 0;
	right: 0;
	height: 100%;
	background: #000;
	opacity: .7;
	z-index: 5002;
	display: none;
}

.single-survey .saving-modal .saving-text {
	font-size: 18px;
	color: #999;
    display: flex;
    justify-content: center;
	text-align: center;
}

.single-survey .saving-modal .saving-text i {
    margin-right: 10px;
}

.single-survey .saving-modal .cf-turnstile {
    display: flex;
    justify-content: center;
    margin-bottom: 16px;
	padding-top:10px;
}

/* RESET STYLES*/
p {
	margin: 0;
	padding: 0;
}

em {
	font-style: normal;
	font-weight: normal;
}`, "",{"version":3,"sources":["webpack://./src/widgets/Survey/SingleSurveyPages/SingleSurvey.css"],"names":[],"mappings":"AAAA;CACC,kJAAkJ;CAClJ,8BAA8B;CAC9B,SAAS;CACT,UAAU;CACV,eAAe;AAChB;;AAEA;CACC,2BAA2B;CAC3B,eAAe;CACf,YAAY;CACZ,WAAW;CACX,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,WAAW;CACX,gBAAgB;CAChB,iBAAiB;CACjB,sBAAsB;AACvB;;AAEA;CACC,aAAa;CACb,eAAe;CACf,gBAAgB;CAChB,sBAAsB;CACtB,WAAW;CACX,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,aAAa;CACb,eAAe;CACf,aAAa;CACb,SAAS;CACT,SAAS;CACT,gBAAgB;CAChB,8BAA8B;CAC9B,6BAA6B;CAC7B,qCAAqC;CACrC,kCAAkC;CAClC,sBAAsB;CACtB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,OAAO;CACP,MAAM;CACN,SAAS;CACT,QAAQ;CACR,YAAY;CACZ,gBAAgB;CAChB,WAAW;CACX,aAAa;CACb,aAAa;AACd;;AAEA;CACC,eAAe;CACf,WAAW;IACR,aAAa;IACb,uBAAuB;CAC1B,kBAAkB;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;CACtB,gBAAgB;AACjB;;AAEA,gBAAgB;AAChB;CACC,SAAS;CACT,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB","sourcesContent":["body {\n\tfont-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n\t-webkit-text-size-adjust: 100%;\n\tmargin: 0;\n\tpadding: 0;\n\tfont-size: 14px;\n}\n\n.single-survey {\n\toverflow: hidden !important;\n\tposition: fixed;\n\theight: 100%;\n\twidth: 100%;\n\tbackground: #f5f5f5;\n}\n\n.single-survey .current-survey-overlay {\n\tdisplay: none;\n}\n\n.single-survey .cancel-button {\n\tdisplay: none;\n}\n\n.single-survey.embedded .cancel-button {\n\tdisplay: block;\n}\n\n.single-survey.webkit .cancel-button {\n\tdisplay: block;\n}\n\n.single-survey.webkit .cancel-button {\n\tdisplay: block;\n}\n\n.single-survey .completion-step .cancel-button {\n\tdisplay: block;\n}\n\n.single-survey .visual-consent-learn-more .cancel-button {\n\tdisplay: block;\n}\n\n.single-survey .survey-complete {\n\tpadding: 16px;\n\twidth: 100%;\n\tmax-width: 768px;\n\tmargin: 16px auto;\n\tbox-sizing: border-box;\n}\n\n.single-survey .survey-complete .survey-complete-message {\n\tpadding: 16px;\n\tfont-size: 21px;\n\tbackground: #FFF;\n\tbox-sizing: border-box;\n\twidth: 100%;\n\tborder-radius: 5px;\n}\n\n.single-survey .survey-complete .survey-complete-message .fa {\n\tfont-size: 35px;\n\tdisplay: block;\n\tmargin-bottom: 8px;\n}\n\n.single-survey .survey-complete .survey-complete-message .fa-times-circle {\n\tcolor: #c4291c;\n}\n\n.single-survey .survey-complete .survey-complete-message .fa-check-circle {\n\tcolor: #5db37e;\n}\n\n.single-survey .saving-modal {\n\tdisplay: none;\n\tz-index: 5003;\n\tposition: fixed;\n\tpadding: 24px;\n\ttop: 50px;\n\tleft: 50%;\n\tmin-width: 360px;\n\tmax-height: calc(100vh - 80px);\n\ttransform: translate(-50%, 0);\n\t-webkit-transform: translate(-50%, 0);\n\t-moz-transform: translate(-50%, 0);\n\tbackground-color: #fff;\n\tborder-radius: 5px;\n\toverflow: hidden;\n}\n\n.single-survey .overlay {\n\tposition: fixed;\n\tleft: 0;\n\ttop: 0;\n\tbottom: 0;\n\tright: 0;\n\theight: 100%;\n\tbackground: #000;\n\topacity: .7;\n\tz-index: 5002;\n\tdisplay: none;\n}\n\n.single-survey .saving-modal .saving-text {\n\tfont-size: 18px;\n\tcolor: #999;\n    display: flex;\n    justify-content: center;\n\ttext-align: center;\n}\n\n.single-survey .saving-modal .saving-text i {\n    margin-right: 10px;\n}\n\n.single-survey .saving-modal .cf-turnstile {\n    display: flex;\n    justify-content: center;\n    margin-bottom: 16px;\n\tpadding-top:10px;\n}\n\n/* RESET STYLES*/\np {\n\tmargin: 0;\n\tpadding: 0;\n}\n\nem {\n\tfont-style: normal;\n\tfont-weight: normal;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
